var map = {
	"./Anteroom.svg": 44274,
	"./Attic.svg": 28953,
	"./Balcony.svg": 2735,
	"./Barn.svg": 3152,
	"./Basement.svg": 26209,
	"./Bathroom.svg": 30476,
	"./Bedroom.svg": 62017,
	"./Boiler Room.svg": 7784,
	"./Carport.svg": 96997,
	"./Cellar.svg": 97839,
	"./Chamber.svg": 98779,
	"./Corridor.svg": 89116,
	"./Dining Area.svg": 9409,
	"./Dining Room.svg": 43251,
	"./Dining.svg": 62092,
	"./Dressing Room.svg": 93989,
	"./Driveway.svg": 84290,
	"./Entrance.svg": 20344,
	"./Equipment Room.svg": 40666,
	"./Front Yard.svg": 93029,
	"./Gallery.svg": 96767,
	"./Garage.svg": 70377,
	"./Garden.svg": 72346,
	"./Ground Floor.svg": 22142,
	"./Guest Bathroom.svg": 68541,
	"./Guest Room.svg": 56278,
	"./Gym.svg": 27925,
	"./Hall.svg": 83009,
	"./Home Theater.svg": 54013,
	"./Kitchen.svg": 20157,
	"./Laundry Room.svg": 24622,
	"./Living Area.svg": 52639,
	"./Living Room.svg": 2767,
	"./Locker Room.svg": 72328,
	"./Nursery.svg": 21273,
	"./Office.svg": 94238,
	"./Outdoors.svg": 58660,
	"./Playroom.svg": 9243,
	"./Pool.svg": 61737,
	"./Rear Wall.svg": 53029,
	"./Second Floor.svg": 1746,
	"./Shed.svg": 67104,
	"./Sleeping Area.svg": 55323,
	"./Stairway.svg": 56448,
	"./Stairwell.svg": 43902,
	"./Storeroom.svg": 33998,
	"./Summer House.svg": 55262,
	"./Swimming Pool.svg": 91822,
	"./Terrace.svg": 59644,
	"./Toilet.svg": 26012,
	"./Upstairs.svg": 83405,
	"./Wardrobe.svg": 20324,
	"./Washroom.svg": 70627,
	"./Wc.svg": 58215,
	"./Windscreen.svg": 7021,
	"./Workshop.svg": 25842,
	"./Workspace.svg": 91104,
	"./list": 84720,
	"./list.json": 84720,
	"./names.txt": 8939,
	"./parseNames": 94282,
	"./parseNames.d.ts": 81278,
	"./parseNames.js": 94282
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2585;